// built-in imports
import { Wrapper, Header } from "./nav.styles";

// internal imports
import { Logo, Navigation, NavBarIcons } from "../index";

const Nav = () => {
  return (
    <Wrapper>
      <Header>
        <Navigation />
        <Logo />
        <NavBarIcons />
      </Header>
    </Wrapper>
  );
};
export default Nav;
